import { combineReducers } from 'redux';
import authReducer from './authReducer';
import sportReducer from './sportReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  sport: sportReducer
});

export default rootReducer;
